<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				工资明细表-补充</div>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<!-- 查询框 -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="10" style="margin-top:50px">
							<el-form-item label="项目" prop="organize_temporary_ids">
								<el-cascader v-model="ruleForm.organize_temporary_ids" @change="changeCascader"
									style="width:100%" collapse-tags :props="props">
								</el-cascader>
							</el-form-item>
						</el-col>
						<el-col :span="10" style="margin-top:50px">
							<el-form-item label="时间" prop="years_date">
								<el-date-picker v-model="ruleForm.years_date" type="month" placeholder="请选择"
									value-format="yyyy-MM" style="width: 100%;">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="姓名" prop="staff_ids">
								<el-select v-model="ruleForm.staff_ids" style="width:100%" placeholder="请选择"
									@change="name" filterable clearable>
									<el-option v-for="item in yglist" :key="item.id" :label="item.staff_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="岗位" prop="post_name">
								<el-input type="text" v-model="ruleForm.post_name" style="width:100%" placeholder=" "
									:disabled="true">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="工资总额" prop="total_wages">
								<el-input type="number" v-model="ruleForm.total_wages" style="width:100%"
									placeholder="请输入工资总额">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="基本工资" prop="base_pay">
								<el-input type="number" v-model="ruleForm.base_pay" style="width:100%"
									placeholder="请输入基本工资">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="岗位工资" prop="post_salary">
								<el-input type="number" v-model="ruleForm.post_salary" style="width:100%"
									placeholder="请输入岗位工资">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="日工资" prop="daily_wage">
								<el-input type="number" v-model="ruleForm.daily_wage" style="width:100%"
									placeholder="请输入日工资">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="应出勤天数" prop="days_attendance">
								<el-input type="number" v-model="ruleForm.days_attendance" style="width:100%"
									placeholder="请输入应出勤天数">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="缺勤天数" prop="absence_days">
								<el-input type="number" v-model="ruleForm.absence_days" style="width:100%"
									placeholder="请输入缺勤天数">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="缺勤扣款" prop="deduction_absence">
								<el-input type="number" v-model="ruleForm.deduction_absence" style="width:100%"
									placeholder="请输入缺勤扣款">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="实出勤天数" prop="actual_attendance_days">
								<el-input type="number" v-model="ruleForm.actual_attendance_days" style="width:100%"
									placeholder="请输入实出勤天数">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="工资额" prop="wages">
								<el-input type="number" v-model="ruleForm.wages" style="width:100%"
									placeholder="请输入工资额">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="满勤" prop="full_work_attendance">
								<el-input type="number" v-model="ruleForm.full_work_attendance" style="width:100%"
									placeholder="请输入满勤">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="餐补" prop="meal_supplement">
								<el-input type="number" v-model="ruleForm.meal_supplement" style="width:100%"
									placeholder="请输入餐补">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="加班时间" prop="overtime">
								<el-input type="number" v-model="ruleForm.overtime" style="width:100%"
									placeholder="请输入加班时间">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="加班金额" prop="overtime_amount">
								<el-input type="number" v-model="ruleForm.overtime_amount" style="width:100%"
									placeholder="请输入加班金额">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="替班" prop="substitute">
								<el-input type="number" v-model="ruleForm.substitute" style="width:100%"
									placeholder="请输入替班">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="话费" prop="telephone_charges">
								<el-input type="number" v-model="ruleForm.telephone_charges" style="width:100%"
									placeholder="请输入话费">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="代岗工资" prop="substitute_salary">
								<el-input type="number" v-model="ruleForm.substitute_salary" style="width:100%"
									placeholder="请输入代岗工资">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="弥补前期" prop="make_up_for_the_early_stage">
								<el-input type="number" v-model="ruleForm.make_up_for_the_early_stage"
									style="width:100%" placeholder="请输入弥补前期">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="奖励" prop="reward">
								<el-input type="number" v-model="ruleForm.reward" style="width:100%"
									placeholder="请输入奖励">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="归还工服押金" prop="return_of_work_clothes_deposit">
								<el-input type="number" v-model="ruleForm.return_of_work_clothes_deposit"
									style="width:100%" placeholder="请输入归还工服押金">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="其他+" prop="other_plus">
								<el-input type="number" v-model="ruleForm.other_plus" style="width:100%"
									placeholder="请输入其他+">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="迟到扣款" prop="late_deduction">
								<el-input type="number" v-model="ruleForm.late_deduction" style="width:100%"
									placeholder="请输入迟到扣款">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="处罚扣款" prop="penalty_deduction">
								<el-input type="number" v-model="ruleForm.penalty_deduction" style="width:100%"
									placeholder="请输入处罚扣款">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="发放工服押金" prop="pay_the_work_clothes_deposit">
								<el-input type="number" v-model="ruleForm.pay_the_work_clothes_deposit"
									style="width:100%" placeholder="请输入发放工服押金">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="其他-" prop="other_reduce">
								<el-input type="number" v-model="ruleForm.other_reduce" style="width:100%"
									placeholder="请输入其他-">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="车补" prop="car_supplement">
								<el-input type="number" v-model="ruleForm.car_supplement" style="width:100%"
									placeholder="请输入车补">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="驻外补助" prop="overseas_subsidies">
								<el-input type="number" v-model="ruleForm.overseas_subsidies" style="width:100%"
									placeholder="请输入驻外补助">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="其他补贴" prop="other_subsidies">
								<el-input type="number" v-model="ruleForm.other_subsidies" style="width:100%"
									placeholder="请输入其他补贴">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="应发补贴小计" prop="subtotal_of_subsidies_payable">
								<el-input type="number" v-model="ruleForm.subtotal_of_subsidies_payable"
									style="width:100%" placeholder="请输入应发补贴小计">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="实发补贴小计" prop="subtotal_of_subsidies_paid">
								<el-input type="number" v-model="ruleForm.subtotal_of_subsidies_paid" style="width:100%"
									placeholder="请输入实发补贴小计">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="应发工资" prop="wages_payable">
								<el-input type="number" v-model="ruleForm.wages_payable" style="width:100%"
									placeholder="请输入应发工资">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="社保扣款" prop="social_security_deduction">
								<el-input type="number" v-model="ruleForm.social_security_deduction" style="width:100%"
									placeholder="请输入社保扣款">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="意外保险" prop="accident_insurance">
								<el-input type="number" v-model="ruleForm.accident_insurance" style="width:100%"
									placeholder="请输入意外保险">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="公积金" prop="accumulation_fund">
								<el-input type="number" v-model="ruleForm.accumulation_fund" style="width:100%"
									placeholder="请输入公积金">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="实发工资（税前）" prop="before_tax_paid_salary">
								<el-input type="number" v-model="ruleForm.before_tax_paid_salary" style="width:100%"
									placeholder="请输入实发工资（税前）">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="个人所得税" prop="individual_income_tax">
								<el-input type="number" v-model="ruleForm.individual_income_tax" style="width:100%"
									placeholder="请输入个人所得税">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="实发工资（税后）" prop="after_tax_paid_salary">
								<el-input type="number" v-model="ruleForm.after_tax_paid_salary" style="width:100%"
									placeholder="请输入实发工资（税后）">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="领取方式" prop="receiving_method">
								<el-select v-model="ruleForm.receiving_method" placeholder="请选择领取方式"
									style="width: 100%;">
									<el-option v-for="item in lqList" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="10"
							v-show="this.ruleForm.receiving_method == '现金' || this.ruleForm.receiving_method == '银行卡' || this.ruleForm.receiving_method == ''">
							<el-form-item label="银行卡号" prop="bank_card_number">
								<el-input type="number" v-model="ruleForm.bank_card_number" style="width:100%"
									:disabled="true" placeholder=" ">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10" v-if="this.ruleForm.receiving_method == '代发'">
							<el-form-item label="银行卡号" prop="bank_card_number">
								<el-input type="number" v-model="ruleForm.bank_card_number" style="width:100%"
									placeholder=" ">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10" v-show="this.ruleForm.receiving_method == '代发'">
							<div @click="StaffFind">
								<el-form-item label="持卡人姓名" prop="cardholder_name">
									<el-input style="width:100%" v-model="ruleForm.cardholder_name"
										onfocus="this.blur();">
									</el-input>
								</el-form-item>
							</div>
							<el-dialog title="选择持卡人" :visible.sync="dialogVisible" width="40%" :center="true"
								:close-on-click-modal="false" :show-close="false">
								<el-row>
									<organizeStaff ref="organizeStaff" type="radio" :accordion="false"
										@commit="saveChange" :staff_id_prop="ruleForm.staff_id"></organizeStaff>
								</el-row>
								<el-row style="text-align: center;">
									<el-button type="goon" style="margin-top: 10px;"
										@click="$refs['organizeStaff'].commit()">确定</el-button>
								</el-row>
							</el-dialog>
						</el-col>
						<el-col :span="10"
							v-show="this.ruleForm.receiving_method == '现金' || this.ruleForm.receiving_method == '银行卡' || this.ruleForm.receiving_method == ''">
							<el-form-item label="持卡人姓名" prop="entry_name">
								<el-input v-model="ruleForm.cardholder_name" style="width:100%" placeholder=" "
									:disabled="true">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="项目名称" prop="entry_name">
								<el-input v-model="ruleForm.entry_name" style="width:100%" placeholder=" "
									:disabled="true">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="身份证号" prop="id_card">
								<el-input type="number" v-model="ruleForm.id_card" style="width:100%" placeholder=" "
									:disabled="true">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="10">
							<el-form-item label="电话号" prop="telephone_number">
								<el-input type="number" v-model="ruleForm.telephone_number" style="width:100%"
									placeholder=" " :disabled="true">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="10">
							<el-form-item label="性别" prop="gender">
								<el-input v-model="ruleForm.gender" style="width:100%" placeholder=" " :disabled="true">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item style="margin-left:30%">
						<el-button type="goon" @click="AddAuditor">保存</el-button>
						<el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>
	</div>
</template>

<script>
	import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
	export default {
		components: {
			organizeStaff: organizeStaff,
		},
		props: ["organizeList"],
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				dialogVisible: false,
				//页面相关
				yglist: [],
				staffList: [],
				tableList: [],
				//领取方式
				lqList: [{
					value: '现金',
					label: '现金'
				}, {
					value: '银行卡',
					label: '银行卡'
				}, {
					value: '代发',
					label: '代发'
				}],
				//表单数据
				ruleForm: {
					id: '',
					staff_id: '',
					staff_name: '',
					project_id: '',
					organize_temporary_ids: '',
					post_id: '',
					post_name: '',
					years_date: this.$globals.getNowTimes(),
					total_wages: '',
					base_pay: '',
					post_salary: '',
					daily_wage: '',
					days_attendance: '',
					absence_days: '',
					deduction_absence: '',
					actual_attendance_days: '',
					wages: '',
					full_work_attendance: '',
					meal_supplement: '',
					overtime: '',
					overtime_amount: '',
					substitute: '',
					telephone_charges: '',
					substitute_salary: '',
					make_up_for_the_early_stage: '',
					reward: '',
					return_of_work_clothes_deposit: '',
					other_plus: '',
					late_deduction: '',
					penalty_deduction: '',
					pay_the_work_clothes_deposit: '',
					other_reduce: '',
					car_supplement: '',
					overseas_subsidies: '',
					other_subsidies: '',
					subtotal_of_subsidies_payable: '',
					subtotal_of_subsidies_paid: '',
					wages_payable: '',
					social_security_deduction: '',
					accident_insurance: '',
					accumulation_fund: '',
					before_tax_paid_salary: '',
					individual_income_tax: '',
					after_tax_paid_salary: '',
					receiving_method: '',
					bank_card_number: '',
					cardholder_name: '',
					entry_name: '',
					id_card: '',
					telephone_number: '',
					gender: '',
				},
				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: false,
				},
			};
		},
		methods: {
			StaffFind() {
				this.dialogVisible = true;
			},
			//设置确定
			saveChange(e) {
				// this.ruleForm.staff_id = e.staff_id;
				this.ruleForm.cardholder_name = e.staff_name;
				this.ruleForm.entry_name = e.staff[0].range;
				this.ruleForm.id_card = e.staff[0].staff_card;
				this.ruleForm.telephone_number = e.staff[0].staff_telephone;
				this.ruleForm.gender = e.staff[0].staff_gender;
				this.ruleForm.bank_card_number = e.staff[0].bank_no;
				this.dialogVisible = false;
			},
			changeCascader() {
				this.ruleForm.project_id = this.ruleForm.organize_temporary_ids[this.ruleForm.organize_temporary_ids
					.length - 1];
				this.ygList()
			},
			// name(e) {
			// 	this.yglist.forEach(item => {
			// 		if (item.id === e) {
			// 			this.ruleForm.cardholder_name = item.staff_name;
			// 			this.ruleForm.post_name = item.post_name;
			// 			this.ruleForm.id_card = item.staff_card;
			// 			this.ruleForm.receiving_method = item.flag;
			// 			this.ruleForm.bank_card_number = item.bank_no;
			// 			this.ruleForm.entry_name = item.organize_name;
			// 			this.ruleForm.telephone_number = item.staff_telephone;
			// 			this.ruleForm.gender = item.staff_gender;
			// 		}
			// 	})
			// },
			async name(e) {
				var url = 'Salary/SalaryDetails';
				var record = {
					staff_id: e,
					years_date: this.ruleForm.years_date + '-01',
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					this.tableList = data.data;
					if (code === '200') {
						if (this.tableList === null) {
							this.ruleForm.total_wages = '0';
							this.ruleForm.base_pay = '0';
							this.ruleForm.post_salary = '0';
							this.ruleForm.daily_wage = '0';
							this.ruleForm.days_attendance = '0';
							this.ruleForm.absence_days = '0';
							this.ruleForm.deduction_absence = '0';
							this.ruleForm.actual_attendance_days = '0';
							this.ruleForm.wages = '0';
							this.ruleForm.full_work_attendance = '0';
							this.ruleForm.meal_supplement = '0';
							this.ruleForm.overtime = '0';
							this.ruleForm.overtime_amount = '0';
							this.ruleForm.substitute = '0';
							this.ruleForm.telephone_charges = '0';
							this.ruleForm.substitute_salary = '0';
							this.ruleForm.make_up_for_the_early_stage = '0';
							this.ruleForm.reward = '0';
							this.ruleForm.return_of_work_clothes_deposit = '0';
							this.ruleForm.other_plus = '0';
							this.ruleForm.late_deduction = '0';
							this.ruleForm.penalty_deduction = '0';
							this.ruleForm.pay_the_work_clothes_deposit = '0';
							this.ruleForm.other_reduce = '0';
							this.ruleForm.car_supplement = '0';
							this.ruleForm.overseas_subsidies = '0';
							this.ruleForm.other_subsidies = '0';
							this.ruleForm.subtotal_of_subsidies_payable = '0';
							this.ruleForm.subtotal_of_subsidies_paid = '0';
							this.ruleForm.wages_payable = '0';
							this.ruleForm.social_security_deduction = '0';
							this.ruleForm.accident_insurance = '0';
							this.ruleForm.accumulation_fund = '0';
							this.ruleForm.before_tax_paid_salary = '0';
							this.ruleForm.individual_income_tax = '0';
							this.ruleForm.after_tax_paid_salary = '0';
							this.yglist.forEach(item => {
								if (item.id === e) {
									this.ruleForm.cardholder_name = item.staff_name;
									this.ruleForm.post_name = item.post_name;
									this.ruleForm.id_card = item.staff_card;
									this.ruleForm.receiving_method = item.flag;
									this.ruleForm.bank_card_number = item.bank_no;
									this.ruleForm.entry_name = item.organize_name;
									this.ruleForm.telephone_number = item.staff_telephone;
									this.ruleForm.gender = item.staff_gender;
								}
							})
						} else {
							this.ruleForm.post_name = this.tableList.post_name;
							this.ruleForm.total_wages = this.tableList.total_wages;
							this.ruleForm.base_pay = this.tableList.base_pay;
							this.ruleForm.post_salary = this.tableList.post_salary;
							this.ruleForm.daily_wage = this.tableList.daily_wage;
							this.ruleForm.days_attendance = this.tableList.days_attendance;
							this.ruleForm.absence_days = this.tableList.absence_days;
							this.ruleForm.deduction_absence = this.tableList.deduction_absence;
							this.ruleForm.actual_attendance_days = this.tableList.actual_attendance_days;
							this.ruleForm.wages = this.tableList.wages;
							this.ruleForm.full_work_attendance = this.tableList.full_work_attendance;
							this.ruleForm.meal_supplement = this.tableList.meal_supplement;
							this.ruleForm.overtime = this.tableList.overtime;
							this.ruleForm.overtime_amount = this.tableList.overtime_amount;
							this.ruleForm.substitute = this.tableList.substitute;
							this.ruleForm.telephone_charges = this.tableList.telephone_charges;
							this.ruleForm.substitute_salary = this.tableList.substitute_salary;
							this.ruleForm.make_up_for_the_early_stage = this.tableList.make_up_for_the_early_stage;
							this.ruleForm.reward = this.tableList.reward;
							this.ruleForm.return_of_work_clothes_deposit = this.tableList
								.return_of_work_clothes_deposit;
							this.ruleForm.other_plus = this.tableList.other_plus;
							this.ruleForm.late_deduction = this.tableList.late_deduction;
							this.ruleForm.penalty_deduction = this.tableList.penalty_deduction;
							this.ruleForm.pay_the_work_clothes_deposit = this.tableList.pay_the_work_clothes_deposit;
							this.ruleForm.other_reduce = this.tableList.other_reduce;
							this.ruleForm.car_supplement = this.tableList.car_supplement;
							this.ruleForm.overseas_subsidies = this.tableList.overseas_subsidies;
							this.ruleForm.other_subsidies = this.tableList.other_subsidies;
							this.ruleForm.subtotal_of_subsidies_payable = this.tableList.subtotal_of_subsidies_payable;
							this.ruleForm.subtotal_of_subsidies_paid = this.tableList.subtotal_of_subsidies_paid;
							this.ruleForm.wages_payable = this.tableList.wages_payable;
							this.ruleForm.social_security_deduction = this.tableList.social_security_deduction;
							this.ruleForm.accident_insurance = this.tableList.accident_insurance;
							this.ruleForm.accumulation_fund = this.tableList.accumulation_fund;
							this.ruleForm.before_tax_paid_salary = this.tableList.before_tax_paid_salary;
							this.ruleForm.individual_income_tax = this.tableList.individual_income_tax;
							this.ruleForm.after_tax_paid_salary = this.tableList.after_tax_paid_salary;
							this.ruleForm.receiving_method = this.tableList.receiving_method;
							this.ruleForm.bank_card_number = this.tableList.bank_card_number;
							this.ruleForm.cardholder_name = this.tableList.cardholder_name;
							this.ruleForm.entry_name = this.tableList.entry_name;
							this.ruleForm.id_card = this.tableList.id_card;
							this.ruleForm.telephone_number = this.tableList.telephone_number;
							this.ruleForm.gender = this.tableList.gender;
							this.ruleForm.post_name = this.tableList.post_name;
							this.ruleForm.receiving_method_name = this.tableList.receiving_method_name;
						}
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			//根据项目查人
			async ygList() {
				var url = 'staff/SelectProjectAll';
				var record = {
					project_id: this.ruleForm.project_id,
				};
				var res = await this.$globals.AxiosPost(url, record);
				this.yglist = res.data;
			},
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			},
			//添加
			AddAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.Add()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			async Add() {
				var url = 'Salary/InsertAndUpdate';
				var record = {
					staff_id: this.ruleForm.staff_ids,
					post_id: this.ruleForm.post_id,
					years_date: this.ruleForm.years_date + '-01',
					total_wages: this.ruleForm.total_wages,
					base_pay: this.ruleForm.base_pay,
					post_salary: this.ruleForm.post_salary,
					daily_wage: this.ruleForm.daily_wage,
					days_attendance: this.ruleForm.days_attendance,
					absence_days: this.ruleForm.absence_days,
					deduction_absence: this.ruleForm.deduction_absence,
					actual_attendance_days: this.ruleForm.actual_attendance_days,
					wages: this.ruleForm.wages,
					full_work_attendance: this.ruleForm.full_work_attendance,
					meal_supplement: this.ruleForm.meal_supplement,
					overtime: this.ruleForm.overtime,
					overtime_amount: this.ruleForm.overtime_amount,
					substitute: this.ruleForm.substitute,
					telephone_charges: this.ruleForm.telephone_charges,
					substitute_salary: this.ruleForm.substitute_salary,
					make_up_for_the_early_stage: this.ruleForm.make_up_for_the_early_stage,
					reward: this.ruleForm.reward,
					return_of_work_clothes_deposit: this.ruleForm.return_of_work_clothes_deposit,
					other_plus: this.ruleForm.other_plus,
					late_deduction: this.ruleForm.late_deduction,
					penalty_deduction: this.ruleForm.penalty_deduction,
					pay_the_work_clothes_deposit: this.ruleForm.pay_the_work_clothes_deposit,
					other_reduce: this.ruleForm.other_reduce,
					car_supplement: this.ruleForm.car_supplement,
					overseas_subsidies: this.ruleForm.overseas_subsidies,
					other_subsidies: this.ruleForm.other_subsidies,
					subtotal_of_subsidies_payable: this.ruleForm.subtotal_of_subsidies_payable,
					subtotal_of_subsidies_paid: this.ruleForm.subtotal_of_subsidies_paid,
					wages_payable: this.ruleForm.wages_payable,
					social_security_deduction: this.ruleForm.social_security_deduction,
					accident_insurance: this.ruleForm.accident_insurance,
					accumulation_fund: this.ruleForm.accumulation_fund,
					before_tax_paid_salary: this.ruleForm.before_tax_paid_salary,
					individual_income_tax: this.ruleForm.individual_income_tax,
					after_tax_paid_salary: this.ruleForm.after_tax_paid_salary,
					receiving_method: this.ruleForm.receiving_method,
					bank_card_number: this.ruleForm.bank_card_number,
					cardholder_name: this.ruleForm.cardholder_name,
					entry_name: this.ruleForm.entry_name,
					id_card: this.ruleForm.id_card,
					telephone_number: this.ruleForm.telephone_number,
					gender: this.ruleForm.gender,
					project_id: this.ruleForm.project_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.trash()
						this.Return();
						return this.$globals.user.id;
					} else {
						this.$message.warning(data);
					}
				}
			},
			//清除数据
			trash() {
				this.ruleForm.id = '';
				this.ruleForm.staff_id = '';
				this.ruleForm.staff_ids = '';
				this.ruleForm.staff_name = '';
				this.ruleForm.organize_temporary_ids = '';
				this.ruleForm.project_id = '';
				this.ruleForm.post_id = '';
				this.ruleForm.post_name = '';
				this.ruleForm.years_date = this.$globals.getNowTime();
				this.ruleForm.total_wages = '';
				this.ruleForm.base_pay = '';
				this.ruleForm.post_salary = '';
				this.ruleForm.daily_wage = '';
				this.ruleForm.days_attendance = '';
				this.ruleForm.absence_days = '';
				this.ruleForm.deduction_absence = '';
				this.ruleForm.actual_attendance_days = '';
				this.ruleForm.wages = '';
				this.ruleForm.full_work_attendance = '';
				this.ruleForm.meal_supplement = '';
				this.ruleForm.overtime = '';
				this.ruleForm.overtime_amount = '';
				this.ruleForm.substitute = '';
				this.ruleForm.telephone_charges = '';
				this.ruleForm.substitute_salary = '';
				this.ruleForm.make_up_for_the_early_stage = '';
				this.ruleForm.reward = '';
				this.ruleForm.return_of_work_clothes_deposit = '';
				this.ruleForm.other_plus = '';
				this.ruleForm.late_deduction = '';
				this.ruleForm.penalty_deduction = '';
				this.ruleForm.pay_the_work_clothes_deposit = '';
				this.ruleForm.other_reduce = '';
				this.ruleForm.car_supplement = '';
				this.ruleForm.overseas_subsidies = '';
				this.ruleForm.other_subsidies = '';
				this.ruleForm.subtotal_of_subsidies_payable = '';
				this.ruleForm.subtotal_of_subsidies_paid = '';
				this.ruleForm.wages_payable = '';
				this.ruleForm.social_security_deduction = '';
				this.ruleForm.accident_insurance = '';
				this.ruleForm.accumulation_fund = '';
				this.ruleForm.before_tax_paid_salary = '';
				this.ruleForm.individual_income_tax = '';
				this.ruleForm.after_tax_paid_salary = '';
				this.ruleForm.receiving_method = '';
				this.ruleForm.bank_card_number = '';
				this.ruleForm.cardholder_name = '';
				this.ruleForm.entry_name = '';
				this.ruleForm.id_card = '';
				this.ruleForm.telephone_number = '';
				this.ruleForm.gender = '';
			},
		},
		created() {
			this.organizeFind();
		},
	};
</script>

<style>
</style>



// WEBPACK FOOTER //
// GzmxBc.vue?9a990d7c